import { useRef, useMemo } from 'react';
import { useConstCallback } from './const-callback';
export function useRefCallback(callback) {
  var callbackRef = useRef();
  callbackRef.current = callback;
  var wrapper = useConstCallback(function () {
    var _a2;

    var _a;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_a = callbackRef.current) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [callbackRef].concat(args));
  });
  return wrapper;
}
export function useLazyGetter(getter, deps) {
  return useMemo(function () {
    var cache = undefined;
    return function () {
      if (!cache) {
        cache = {
          value: getter()
        };
      }

      return cache.value;
    };
  }, deps);
}